import { useState } from 'react'

const usePaginateArray = <T>(data: Array<T>, itemsPerPage: number) => {
  const [currentPage, setCurrentPage] = useState(1)

  const totalPages = Math.ceil(data.length / itemsPerPage)
  // Clamp against totalPages -- a page index left over from a larger dataset
  // (e.g. the caller switched to a smaller section/list, or a refetch
  // narrowed the data, without resetting the page itself) would otherwise
  // slice past the end and silently render nothing, with no pagination
  // control visible to get back (that's gated on totalPages > 1 by callers).
  // Math.max(totalPages, 1) keeps this at page 1 rather than page 0 when
  // data is empty.
  const safePage = Math.min(currentPage, Math.max(totalPages, 1))

  const setPage = page => {
    setCurrentPage(page)
  }

  const startIndex = (safePage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage

  const paginatedData = data.slice(startIndex, endIndex)

  return {
    currentPage: safePage,
    setPage,
    paginatedData,
    totalPages,
  }
}

export default usePaginateArray
